module.exports = __webpack_public_path__ + "static/media/Bellanaisa.eaf999ba.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Bellanaisa.woff
// module id = 2281
// module chunks = 49